import React, { useState, useMemo, ComponentType } from "react";
import styled from "styled-components";
import { PanelType } from "../PanelType";
import { ActivePanelTypeContext } from "./ActivePanelTypeContext";
import Panel from "@adsk/alloy-react-panel";

// Ensures the main content area shrinks when the detail panel opens.
// Targets the first direct child of Panel.Container (the issues table wrapper).
// If Panel.Container's internal DOM structure changes, revisit this selector.
const StyledPanelContainer = styled(Panel.Container)`
  > :first-child {
    min-width: 0;
    flex: 1;
  }
`;

export const IssuesPanelContainer: React.FC = ({ children }) => {
  const [activePanel, setActivePanel] = useState(PanelType.None);

  const value = useMemo(
    () => [activePanel, setActivePanel] as ActivePanelTypeContext,
    [activePanel]
  );
  return (
    <ActivePanelTypeContext.Provider value={value}>
      <StyledPanelContainer>{children}</StyledPanelContainer>
    </ActivePanelTypeContext.Provider>
  );
};

export const withIssuesPanelContainer =
  <T extends {}>(WrappedComponent: ComponentType<T>) =>
  (props: T) => {
    return (
      <IssuesPanelContainer>
        <WrappedComponent {...props} />
      </IssuesPanelContainer>
    );
  };
